module.exports = __webpack_public_path__ + "static/img/logo-light.2a03d966.png";